import { useState, useEffect } from "react";
import {
  showroomGallery as defaultGallery,
  allBrands as defaultBrands,
  AUTH_PROMO_FALLBACK_IMAGE,
} from "../data/content";

const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

const defaultEvents = [
  { title: "Salon & événements", date: "À venir", excerpt: "Retrouvez-nous sur les salons professionnels.", link: "/contact", tag: "Événement", accent: "#190276" },
  { title: "Nouveautés produits", date: "2025", excerpt: "Découvrez les dernières gammes.", link: "/showroom", tag: "Showroom", accent: "#F2B531" },
  { title: "Offres & promotions", date: "Saison", excerpt: "Bénéficiez d'offres sur une sélection de produits.", link: "/contact", tag: "Devis", accent: "#f7040a" },
];

export function useSiteContent() {
  const [content, setContent] = useState({
    showroomGallery: defaultGallery,
    events: defaultEvents,
    promotions: [],
    brands: defaultBrands,
    settings: { sliderAutoRotate: true, sliderIntervalSec: 3 },
    popup: { enabled: false, title: "", message: "", image: "", link: "", linkLabel: "Voir" },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/api/content`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (cancelled) return;
        if (data) {
          const apiGallery = Array.isArray(data.showroomGallery) ? data.showroomGallery : [];
          setContent({
            showroomGallery: apiGallery.length >= defaultGallery.length ? apiGallery : defaultGallery,
            events: Array.isArray(data.events) && data.events.length > 0 ? data.events : defaultEvents,
            promotions: Array.isArray(data.promotions) ? data.promotions : [],
            brands: Array.isArray(data.brands) && data.brands.length > 0 ? data.brands : defaultBrands,
            settings: data.settings && typeof data.settings.sliderAutoRotate !== "undefined"
              ? { sliderAutoRotate: !!data.settings.sliderAutoRotate, sliderIntervalSec: Math.max(1, parseInt(data.settings.sliderIntervalSec, 10) || 3) }
              : { sliderAutoRotate: true, sliderIntervalSec: 3 },
            popup: data.popup && typeof data.popup.enabled !== "undefined"
              ? { enabled: !!data.popup.enabled, title: data.popup.title || "", message: data.popup.message || "", image: data.popup.image || "", link: data.popup.link || "", linkLabel: data.popup.linkLabel || "Voir" }
              : { enabled: false, title: "", message: "", image: "", link: "", linkLabel: "Voir" },
            authPromo:
              data.authPromo && typeof data.authPromo === "object"
                ? {
                    enabled: data.authPromo.enabled !== false,
                    image: String(data.authPromo.image || "").trim(),
                    href: String(data.authPromo.href || "").trim(),
                    alt: String(data.authPromo.alt || "").trim(),
                  }
                : {
                    enabled: true,
                    image: AUTH_PROMO_FALLBACK_IMAGE,
                    href: "",
                    alt: "",
                  },
          });
        }
      })
      .catch(() => { if (!cancelled) setContent((c) => c); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { ...content, loading };
}
